import customerServiceSchema from "../../shared/schemas/customerService.js";
import { showFormErrors, toggleCustomerFields, sendFormToServer, getFormData, displayFormMessage, hideLoadingMessage, displayLoadingMessage, handleFileUpload, clearFormErrors, restoreFormData } from "/common/client/js/utils/formUtils.js";
import { getCategoryOptions, initializeSelection } from "/common/client/js/utils/choices.js";
import { i18n } from "/common/client/js/i18n/i18n_instance.js";
import { noSerialProducts } from "../../../common/client/js/utils/serialNumberProductsLists.js";
import { withoutSpamFields } from "/common/server/middleware/spamGuard.ts";
export function toggleTerminFields() {
    const appointmentFields = document.getElementById("appointment-fields");
    const asapCheckbox = document.getElementById("asap");


    if (asapCheckbox.checked) {
        appointmentFields.classList.add("hidden");
    } else {
        appointmentFields.classList.remove("hidden");
    }
}

export function initTerminListener() {
    const asapCheckbox = document.getElementById("asap");
    toggleTerminFields();
    asapCheckbox.addEventListener("change", toggleTerminFields);
}
export function initGuaranteelistener() {
    const guarantee = document.getElementById('guarantee');
    const info = document.createElement('p');
    info.classList.add('hidden', 'info');
    guarantee.addEventListener('change', () => {
        guarantee.parentNode.appendChild(info);
        info.textContent = guarantee.value === 'Nein' ? 'wenn kein Garantieanspruch besteht, ist dies kostenpflichtig' : '';
        info.classList.toggle('hidden', guarantee.value !== 'Nein');
    })
}
export function initSelects() {
    const selects = document.querySelectorAll('.article-select');
    selects.forEach(select => initializeSelection(select));
}

export function initObserver() {
    const container = document.getElementById('defectDeviceList');
    const observer = new MutationObserver(handleMutations); -
        observer.observe(container, { childList: true });
}

export function handleMutations(mutationsList) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            const newSelect = mutation.addedNodes[0]?.querySelector('.article-select');
            if (newSelect) {
                initializeSelection(newSelect);
            }
        }
    }
}

export function initDefectiveDeviceCount() {
    const defectiveDeviceCount = document.getElementById('defectiveDeviceCount');
    defectiveDeviceCount.addEventListener('change', generateDefectFields);
}

export function initAddButtons() {
    const addButtons = document.querySelectorAll('.add-item');
    addButtons.forEach(button => {
        button.addEventListener('click', () => {
            addProductRow(button.dataset.category);
        });
    });
}

export function initCustomerNumberListener() {
    const hasNoCustomerNumberCheckbox = document.getElementById(
        "hasNoCustomerNumber"
    );
    toggleCustomerFields();
    hasNoCustomerNumberCheckbox.addEventListener("change", toggleCustomerFields);
}

export function initWarrantyNumberListener() {
    const hasNoWarrantyNumberCheckbox = document.getElementById(
        "hasNoWarrantyNumber"
    );
    toggleWarrantyNumberFields();
    hasNoWarrantyNumberCheckbox.addEventListener("change", toggleWarrantyNumberFields);
}

export function toggleWarrantyNumberFields() {
    const hasNoWarrantyNumber = document.getElementById("hasNoWarrantyNumber").checked;
    const warrantyNumberGroup = document.getElementById("warrantyNumberGroup");
    const noWarrantyNumberFields = document.getElementById("noWarrantyNumberFields");

    warrantyNumberGroup.classList.toggle("hidden", hasNoWarrantyNumber);
    noWarrantyNumberFields.classList.toggle("hidden", !hasNoWarrantyNumber);

    document.getElementById("warrantyNumber").required = !hasNoWarrantyNumber;
}

export function initCustomerTypeListener() {
    const radios = document.querySelectorAll('input[name="customerType"]');
    toggleVatIdField();
    radios.forEach(radio => radio.addEventListener("change", toggleVatIdField));
    document.getElementById("hasNoCustomerNumber").addEventListener("change", toggleVatIdField);
}

// Customer type, VAT ID and company fields only apply to new customers (no customer number)
export function toggleVatIdField() {
    const isNewCustomer = document.getElementById("hasNoCustomerNumber").checked;
    const isBusiness = isNewCustomer && document.querySelector('input[name="customerType"]:checked')?.value === "business";
    const vatId = document.getElementById("vatId");

    document.getElementById("customerTypeGroup").classList.toggle("hidden", !isNewCustomer);
    document.getElementById("vatIdGroup").classList.toggle("hidden", !isBusiness);
    vatId.required = isBusiness;
    if (!isBusiness) vatId.value = "";

    // Company fields are only shown for business customers
    ["customerCompany", "customerCompanyEmail"].forEach(id => {
        const input = document.getElementById(id);
        input.closest(".form-group").classList.toggle("hidden", !isBusiness);
        if (!isBusiness) input.value = "";
    });
    if (isNewCustomer) document.getElementById("customerCompany").required = isBusiness;
}

export function initBillingAddressListener(billingAutocomplete) {
    const checkbox = document.getElementById("billingAddressDiffers");
    toggleBillingAddressFields();
    checkbox.addEventListener("change", () => {
        if (!checkbox.checked) billingAutocomplete.resetAllFields();
        toggleBillingAddressFields();
    });
}

export function toggleBillingAddressFields() {
    const differs = document.getElementById("billingAddressDiffers").checked;
    document.getElementById("billingAddressGroup").classList.toggle("hidden", !differs);
}

export function createProductRow(category, index) {
    const row = document.createElement('div');
    const options = getCategoryOptions(category);
    let optionsHtml = options.optionsHtml;
    row.className = 'item';

    row.innerHTML = `
    <div class="flex-column">
      <select data-index="${index}" name="${category}[${index}][articleNumber]" class="article-select">
          ${optionsHtml}
      </select>
      <input type="number" name="${category}Quantity[]" placeholder="Anzahl" min="0" />
      <button type="button" class="removeDevice">❌ Entfernen</button>
    `;
    row.querySelector('.removeDevice').addEventListener('click', () => {
        row.remove();
    });

    return row;
}

export function addProductRow(containerId) {
    const container = document.getElementById(containerId);
    const newRow = createProductRow(containerId);
    container.appendChild(newRow);
    initializeSelection(newRow.querySelector('.article-select'), container.querySelectorAll('.item').length - 1);
}

export function generateDefectFields() {
    let count = parseInt(document.getElementById('defectiveDeviceCount').value, 10);
    if (!count) count = 0;
    const container = document.getElementById('defectDeviceList');
    const options = getCategoryOptions('all');


    const currentCount = container.children.length;

    // If more fields are needed → add new ones
    for (let i = currentCount + 1; i <= count; i++) {
        const fieldGroup = document.createElement('div');
        fieldGroup.className = 'form-row grid-3';
        fieldGroup.innerHTML = `
            <div class="form-group">
                <select required data-index="${i}" class="article-select" name="defectiveDevice[${i}][articleNumber]">
                ${options.optionsHtml}
                </select>
                <label class="label">${i18n.__("article_number")}</label>
            </div>

            <div class="form-group">
                <input type="text" name="defectiveDevice[${i}][serialNumber]"/>
                <label class="label">Seriennummer*</label>
            </div>

            <div class="form-group">
                <label class="label">Fehlerbeschreibung*</label>
                <input required type="text" name="defectiveDevice[${i}][errorDescription]"/>
            </div>
            `;

        const select = fieldGroup.querySelector('.article-select');
        const serialInput = fieldGroup.querySelector(`input[name="defectiveDevice[${i}][serialNumber]"]`);
        select.addEventListener('change', () => {
            if (noSerialProducts.includes(select.value) || !options.options.includes(select.value)) {
                serialInput.parentNode.classList.add('hidden'); serialInput.value = "";
            } else {
                serialInput.parentNode.classList.remove('hidden');
            }
        });

        container.appendChild(fieldGroup);
    }

    // If fewer fields are needed → remove extras
    while (container.children.length > count) {
        container.removeChild(container.lastChild);
    }
}

export function collectDevices() {
    const devices = [];
    const categorySections = document.querySelectorAll('.category-group > div[id]');
    categorySections.forEach(section => {
        const items = section.querySelectorAll('.item');

        items.forEach(item => {
            const select = item.querySelector('select.article-select');
            const quantityInput = item.querySelector('input[type="number"]');

            const articleNumber = select?.value?.trim();
            const quantity = parseInt(quantityInput?.value || "0", 10);

            // Only include devices with a selected article number and quantity > 0
            if (articleNumber && quantity > 0) {
                devices.push({
                    articleNumber,
                    quantity
                });
            }
        });
    });

    return devices;
}

export function initSubmitListener(autocompletes) {
    const form = document.querySelector('#customerServiceForm');
    form.addEventListener('submit', function (event) {
        console.log('Form submitted');
        event.preventDefault();
        handleFormSubmit(form, autocompletes);
    });
}
export async function handleFormSubmit(form, autocompletes) {
    clearFormErrors(form);
    const submitButton = document.querySelector(".submit-button");
    const noWarrantyNumberFields = document.getElementById("noWarrantyNumberFields");
    const hasNoWarrantyNumber = document.getElementById("hasNoWarrantyNumber").checked;

    const formData = new FormData(form);
    if (!hasNoWarrantyNumber) {
        const noWarrantyInputs = noWarrantyNumberFields.querySelectorAll("input, select");
        noWarrantyInputs.forEach(element => formData.delete(element.name));
    }
    else if (hasNoWarrantyNumber) formData.set("warrantyNumber", "")

    if (!formData.has("hasNoCustomerNumber")) formData.delete("customerType");
    if (formData.get("customerType") !== "business") formData.delete("vatId");
    if (!formData.has("billingAddressDiffers")) {
        ["billingName", "billingPostalCodeNumber","billingCity", "billingStreet", "billingHouseNumber"]
            .forEach(name => formData.delete(name));
    }

    const defectiveDevices = processDefectiveDevices(formData)
    const installedDevices = collectDevices();
    const data = getFormData(formData);
    data.defectiveDevices = defectiveDevices
    data.devices = installedDevices;
    submitButton.disabled = true;

    console.log('data', data);
    try {
        displayLoadingMessage()
        await customerServiceSchema.validateAsync(withoutSpamFields(data), { abortEarly: false });
        const response = await sendFormToServer(JSON.stringify(data), "/customer-service");

        if (response.success) {
            autocompletes.forEach(autocomplete => autocomplete.resetAllFields());
            form.reset();
            toggleVatIdField();
            toggleBillingAddressFields();
            displayFormMessage(response.message, "success");
        } else throw new Error(response.message);

    } catch (error) {
        if (error.isJoi) {
            console.error("Validation error:", error.details);
            showFormErrors(error, form);
        } else if (error.name === 'TypeError' && error.message.includes('fetch')) {
            console.error("Network error:", error.message);
            displayFormMessage("Netzwerkverbindung ist fehlgeschlagen", "error");
        } else {

            console.error("Unexpected error:", error);
            displayFormMessage(error.message, "error");
        }
    }
    finally {
        hideLoadingMessage()
        submitButton.disabled = false;
        submitButton.classList.remove('running')

    }
}

export function processDefectiveDevices(formData) {
    const count = parseInt(formData.get('defectiveDeviceCount'));
    const devices = [];
    for (let i = 1; i <= count; i++) {
        const articleNumber = formData.get(`defectiveDevice[${i}][articleNumber]`) || "";
        const serialNumber = formData.get(`defectiveDevice[${i}][serialNumber]`) || "";
        const errorDescription = formData.get(`defectiveDevice[${i}][errorDescription]`) || "";
        devices.push({ articleNumber, serialNumber, errorDescription });
        formData.delete(`defectiveDevice[${i}][articleNumber]`);
        formData.delete(`defectiveDevice[${i}][serialNumber]`);
        formData.delete(`defectiveDevice[${i}][errorDescription]`);
    }
    return devices;
}

export function initOnlineSeriveChecker() {
    const serviceType = document.querySelector('[name=serviceType]')
    const onlineService = document.querySelector('.onlineServiceType')
    serviceType.addEventListener('change', () => {
        if (serviceType.value == "online")
            onlineService.classList.remove('hidden')
        else
            onlineService.classList.add('hidden')
    })
}